import { useCatalogueStore } from '@/store/catalogue-store';

export function ProfitMarginInput() {
  const profitMargin = useCatalogueStore((state) => state.profitMargin);
  const setProfitMargin = useCatalogueStore((state) => state.setProfitMargin);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    setProfitMargin(isNaN(value) ? 0 : value);
  };

  return (
    <div className="profit-margin-input-container" data-testid="profit-margin-input-container">
      <label htmlFor="profit-margin-input" className="profit-margin-label">
        Profit Margin (%):
      </label>
      <input
        id="profit-margin-input"
        type="number"
        data-testid="profit-margin-input"
        className="profit-margin-input"
        value={profitMargin}
        onChange={handleChange}
        placeholder="0"
      />
    </div>
  );
}
